import { render } from "./slot-editor.vue?vue&type=template&id=0b84d2d1"
import script from "./slot-editor.vue?vue&type=script&lang=js"
export * from "./slot-editor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__